import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useSelector } from "react-redux";
import { investorApi } from "../api/api";
import KYCCompleted from "../components/Pages/KYC/KYCCompleted";

import KYCPending from "../components/Pages/KYC/KYCPending";
import KYCForm from "../components/Pages/KYC/KYCNew";
import KYCRejected from "../components/Pages/KYC/KYCRejected";
import Loader from "../components/common/Loader";

const KYCScreen = () => {
  const userId = useSelector((state) => state.user.userId);
  const isKyc=useSelector((state)=>state.user.isKyc);
  const [kycStatus, setKycStatus] = useState("New");
  const [loading, setLoading] = useState(true);
  const theme=useSelector((data)=>data.themeValue.colors);
  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchKYCStatus = async () => {
      try {
        if (!userId) return;
      
        const response = await investorApi.getKycDetails(userId);

        if (response.status === 200) {
          const statusList = response.data.map((item) => item.STATUS);
          setKycStatus(statusList[0] || "New");
        } else {
          alert("Failed to fetch KYC details.");
        }
      } catch (error) {
        console.error("KYC Fetch Error:", error);
        alert("Something went wrong while fetching KYC status.");
      } finally {
        setLoading(false);
      }
    };

    fetchKYCStatus();
  }, [userId]);
  const layoutConfig = {
    New: KYCForm,
    Completed: KYCCompleted,
    InProgress: KYCPending,
    Rejected: KYCRejected,
  };

  const ActiveComponent = layoutConfig[kycStatus] || KYCForm;


 function KycStatusMessage({ kycStatus, handleUploadKyc }) {
  if (kycStatus === 'Pending') {
    return (
      <Box>
        <Typography color="warning.main" gutterBottom sx={{color:theme.text}}>
          Please upload your KYC documents to proceed.
        </Typography>
      </Box>
    );
  }

  if (kycStatus === 'InProgress') {
    return (
      <Typography color="info.main" sx={{color:theme.text}}>
        KYC verification is in progress. Please wait for admin approval.
      </Typography>
    );
  }

  if (kycStatus === 'Rejected') {
    return (
      <Box>
        <Typography color="error" gutterBottom sx={{color:theme.text}}>
          Your KYC was rejected. Please re-upload the correct documents.
        </Typography>
      </Box>
    );
  }

  if (kycStatus === 'Completed') {
    return (
      <Typography color="success.main" sx={{color:theme.text}}>
         KYC Completed. You can now add property.
      </Typography>
    );
  }

  return null;
}



  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 ,minHeight:"90vh"}}>
      {/* <Typography variant="h5" fontWeight="bold" mb={3}>
        Know Your Customer (KYC)
      </Typography> */}
    {isKyc !== 'Completed' && <KycStatusMessage kycStatus={isKyc} />}


      {loading ? (
       <Loader/>
      ) : (
        <Box>
          <ActiveComponent userId={userId} kycStatus={kycStatus} />
        </Box>
      )}
    </Container>
  );
};

export default KYCScreen;
